import type { EnhancedDomain } from 'awr-domain'

import { useResourceUrl } from '@salsita-ai/platform-project-sdk/react'
import { LegacySummary, LegacySummaryItem } from '@salsita-ai/platform-project-sdk/ui'

export const AppSummary = (props: { summary: EnhancedDomain.$Deck['$summary'] }) => {
  const { summary } = props

  const { getResourceUrl } = useResourceUrl()

  return (
    <LegacySummary
      title="Product Summary"
      description="Below is a detailed summary of your wire balustrade product selections."
      formattedPrice={null}
      summaryLabel="Total Price"
    >
      {summary.map(item => (
        <LegacySummaryItem
          key={item.key}
          title={`${item.amount} x ${item.title}`}
          subtitle={item.subtitle}
          thumbnailUrl={
            item.thumbnailUrl
              ? URL.canParse(item.thumbnailUrl)
                ? item.thumbnailUrl
                : getResourceUrl(item.thumbnailUrl)
              : undefined
          }
          selectable={!!item.link}
          onClick={() => {
            if (item.link) {
              window.open(item.link, '_blank')
            }
          }}
        />
      ))}
    </LegacySummary>
  )
}
